import React, { useState } from "react";
import { useAxiosContext } from "../../context/AxiosContext";
import ButtonActionIcon from "../../components/BuilderComponents/ButtonActionIcon";
import Input from "../../components/FormComponents/Input";
import Textarea from "../../components/FormComponents/Textarea";
import Button from "../../components/FormComponents/Button";
import Label from "../../components/FormComponents/Label";
import { toastError } from "../../utils/toastUtils";

const OrgModal = ({ editData, addOrganization, editOrganization }) => {
  const [organizationData, setOrganizationData] = useState(editData);
  const [logoFile, setLogoFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { axiosInstance, handleError, handleSuccess } = useAxiosContext();

  const uploadLogo = async () => {
    if (!logoFile) return null;
    const formData = new FormData();
    formData.append("myFile", logoFile);
    try {
      const response = await axiosInstance.post(`/global/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      handleSuccess(response.message);
      return response.data.name;
    } catch (error) {
      handleError(error);
      return null;
    }
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      let updatedLogo = organizationData.logo;
      if (logoFile) {
        const uploadedLogo = await uploadLogo();
        if (uploadedLogo) {
          updatedLogo = uploadedLogo;
        } else {
          toastError("Error uploading logo. Please try again later.");
          return;
        }
      }

      const finalPayload = {
        ...organizationData,
        logo: updatedLogo
      };

      if (editData.id !== undefined) {
        await editOrganization(finalPayload);
      } else {
        await addOrganization(finalPayload);
      }

      handleSuccess("Organization saved successfully.");
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteLogo = () => {
    setOrganizationData({ ...organizationData, logo: "" });
    setLogoFile(null);
  };

  return (
    <div className="builder_form">
      <Input
        label="Enter Organization Name"
        value={organizationData.name}
        onChange={(e) =>
          setOrganizationData({
            ...organizationData,
            name: e.target.value
          })
        }
      />
      <Textarea
        value={organizationData.description}
        label="Enter Organization Description"
        onChange={(e) =>
          setOrganizationData({
            ...organizationData,
            description: e.target.value
          })
        }
      />
      {organizationData.id !== undefined && (
        <>
          <Label>{`Add Logo ${organizationData.logo || ""}`}</Label>
          <div className="d_flex align_center gap_1">
            <Input type="file" accept="image/*" name="logo" onChange={(e) => setLogoFile(e.target.files[0])} />
            {organizationData.logo && <ButtonActionIcon type="delete" title="delete logo" onClick={handleDeleteLogo} />}
          </div>
        </>
      )}
      <Button onClick={handleSave} isLoading={isLoading}>
        {editData.id !== undefined ? "+ Edit Organization" : "+ Add Organization"}
      </Button>
    </div>
  );
};

export default OrgModal;
